import TabPage from "./../../factories/tab-page";
import GenericListTab from "./../../factories/generic-list-tab";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import * as ko from "knockout";
import SummaryReportFilterTabDialog from "./../dialogs/summary-report-filter-tab-dialog";
class ShiftbookTransferDefinition extends GenericListTab {
    Bao = Bao;
    DialogWidth = 600;
    Categories: KnockoutObservableArray<{
        CategoryFullName: string;
        CategoryStructureId: string;
    }> = ko.observableArray();
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Models.subscribe(() => {
            this.Selection([]);
        });
        this.loadCategories();
    }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    GetCategoryName(categoryStructureId): string {
        let category = this.Categories().filter(c => c.CategoryStructureId == categoryStructureId);
        if (category.length > 0) {
            return category[0].CategoryFullName;
        }
        else {
            return "";
        }
    }
    private loadCategories = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("SummaryReportFilterTab/GetCategories")
            .done(categories => {
            this.Categories(categories);
            this.TabPage.IsLoading(false);
        });
    };
}
export default ShiftbookTransferDefinition;